<div *ngIf="album != null" class="album-breadcrumbs">
    <div class="album-back-to-gallery" *ngIf="album.Id !== 0" (click)="onBreadcrumbClicked(null)">Back to Gallery</div>
    <div class="album-breadcrumb-list" *ngIf="album.Breadcrumbs.length > 0">
        <div class="album-breadcrumb" *ngFor="let breadcrumb of album.Breadcrumbs" (click)="onBreadcrumbClicked(breadcrumb)">{{breadcrumb.Name}}</div>
    </div>
</div>

<div *ngIf="folder != null" class="album-breadcrumbs">
    <div class="album-breadcrumb-list" *ngIf="folder.Breadcrumbs.length > 0">
        <div class="album-breadcrumb" *ngFor="let breadcrumb of folder.Breadcrumbs" (click)="onDocCenterBreadcrumbClicked(breadcrumb)">{{breadcrumb.Name}}</div>
    </div>
</div>
